import {
  BOOK_COMPONENT_CATEGORY_IDS,
  HARDWARE_PRODUCT_TYPE_ID,
} from "constants/config";

export const getOrderAddressDetails = (order) => order?.addressDetails ?? null;

export const getOrderBillingAddress = (order) => {
  const details = getOrderAddressDetails(order);
  return details?.billingAddress ?? null;
};

export const getOrderShippingAddress = (order) => {
  const details = getOrderAddressDetails(order);
  return details?.shippingAddress ?? null;
};

export const orderHadShippingAddress = (order) => {
  const shipping = getOrderShippingAddress(order);
  if (!shipping || typeof shipping !== "object") {
    return false;
  }

  return Boolean(
    shipping.addressLine1 ||
      shipping.city ||
      shipping.recipientName ||
      shipping.postalCode ||
      shipping.district
  );
};

export const cartRequiresShippingAddress = (
  selectedPackageSubscriptions = []
) =>
  selectedPackageSubscriptions.some(
    (pkg) =>
      (pkg.componentProductTypeIds || []).includes(HARDWARE_PRODUCT_TYPE_ID) ||
      (pkg.componentCategoryIds || []).some((categoryId) =>
        BOOK_COMPONENT_CATEGORY_IDS.includes(categoryId)
      )
  );

export const resolveRequiresShippingAddress = (
  selectedPackageSubscriptions,
  previousOrderHadShipping = false
) =>
  cartRequiresShippingAddress(selectedPackageSubscriptions) ||
  Boolean(previousOrderHadShipping);

export const mapCapturedAddressToForm = (address) => {
  if (!address) {
    return {};
  }
  return {
    recipientName: address.recipientName,
    parentName: address.parentName,
    recipientPhoneNumber: address.maskedPhoneNo,
    recipientEmail: address.email,
    addressLine1: address.addressLine1,
    addressLine2: address.addressLine2,
    street: address.street,
    city: address.city,
    district: address.district,
    state: address.state,
    pincode: address.postalCode,
    landmark: address.landmark,
  };
};
